import posthog from 'posthog-js'

posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
  api_host: 'https://app.posthog.com'
})

export { posthog }
